<template>
    <div>
        <admin-dash-intro v-if="part.type == 'intro'"
                             :part="part"></admin-dash-intro>

        <admin-dash-news v-else-if="part.type == 'news'"
                         :part="part"></admin-dash-news>

        <admin-dash-coupons v-else-if="part.type == 'coupons'"
                               :part="part"></admin-dash-coupons>

        <admin-dash-occupancy v-else-if="part.type == 'occupancy'"
                                :part="part"></admin-dash-occupancy>

        <admin-dash-revenue v-else-if="part.type == 'revenue'"
                              :part="part"></admin-dash-revenue>

        <admin-dash-events-panel v-else-if="part.type == 'events'"
                            :part="part"></admin-dash-events-panel>

        <admin-dash-absences-panel v-else-if="part.type == 'absences'"
                                 :part="part"></admin-dash-absences-panel>

        <admin-dash-schedules-panel v-else-if="part.type == 'schedules'"
                                    :part="part"></admin-dash-schedules-panel>

        <div v-else class="panel panel-flat">
            <div class="panel-heading">
                KOMPONENTTYP OREGISTRERAD
            </div>
            <div class="panel-body">
                Okänd komponenttyp:
                <div><b>{{part.title}}</b></div>
                <div><b>{{part.type}}</b></div>
            </div>
        </div>
    </div>
</template>

<script>
    import AdminDashOccupancy from "./AdminDashOccupancy";
    import AdminDashSchedulesPanel from "./AdminDashSchedulesPanel";
    import AdminDashAbsencesPanel from "./AdminDashAbsencesPanel";

    export default {
        components: {AdminDashAbsencesPanel, AdminDashSchedulesPanel, AdminDashOccupancy},
        props: ['part'],
        name: "admin-create-dash-component"
    }
</script>

<style scoped>

</style>